// extracted by mini-css-extract-plugin
export var audioPlayer = "_qe-0";